import * as yup from 'yup';

export const commonTariffMappingValidation: { [x: string]: any; } = {
    tariffType: yup.string().required("Missing."),
    tariffCode: yup.string().required("Missing."),
    chargeType: yup.string().required("Missing."),
    // loaLimitFrom: yup.string().required("Missing."),
    // loaLimitTo: yup.string().required("Missing."),
    // overWeightFrom: yup.string().required("Missing."),
    // overWeightTo: yup.string().required("Missing."),
    activeInd: yup.string().required("Missing."),
};

export const createTariffMappingValidation: { [x: string]: any; } = {
    ...commonTariffMappingValidation,
};

export const createTariffMappingValidationSchema = yup.object().shape(createTariffMappingValidation);

